import { useState } from 'react'
import { usePerformers } from '@/hooks/usePerformers'
import {
  PerformersTable,
  type PerformerFilter,
} from '@/components/features/performers/PerformersTable'

export function Performers() {
  const { data: performers, isLoading, error } = usePerformers()
  const [filter, setFilter] = useState<PerformerFilter>('all')

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="text-muted-foreground">Loading performers...</div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="rounded-lg border border-destructive/50 bg-destructive/10 p-6">
        <h2 className="font-semibold text-destructive">Failed to load performers</h2>
        <p className="mt-1 text-sm text-muted-foreground">{error.message}</p>
      </div>
    )
  }

  if (!performers || performers.length === 0) {
    return (
      <div className="space-y-4">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Performers</h1>
          <p className="text-muted-foreground mt-2">No performers found.</p>
        </div>
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Performers</h1>
        <p className="text-muted-foreground mt-2">
          Browse and manage performer records. Click a row to view details.
        </p>
      </div>
      <PerformersTable performers={performers} filter={filter} onFilterChange={setFilter} />
    </div>
  )
}
